/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as JoinRouteImport } from './routes/join'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as setupSetupRouteImport } from './routes/(setup)/setup'
import { Route as unauthForgotRouteImport } from './routes/(unauth)/forgot'
import { Route as unauthLoginRouteImport } from './routes/(unauth)/login'
import { Route as unauthRegisterRouteImport } from './routes/(unauth)/register'
import { Route as AuthDashboardRouteImport } from './routes/_auth/_dashboard'
import { Route as AuthWorkoutSessionRouteImport } from './routes/_auth/workout-session'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as AuthDashboardBrandingRouteImport } from './routes/_auth/_dashboard/branding'
import { Route as AuthDashboardChatRouteImport } from './routes/_auth/_dashboard/chat'
import { Route as AuthDashboardCheckinsRouteImport } from './routes/_auth/_dashboard/checkins'
import { Route as AuthDashboardDashboardRouteImport } from './routes/_auth/_dashboard/dashboard'
import { Route as AuthDashboardExercisesRouteImport } from './routes/_auth/_dashboard/exercises'
import { Route as AuthDashboardFoodsRouteImport } from './routes/_auth/_dashboard/foods'
import { Route as AuthDashboardGettingStartedRouteImport } from './routes/_auth/_dashboard/getting-started'
import { Route as AuthDashboardHabitsRouteImport } from './routes/_auth/_dashboard/habits'
import { Route as AuthDashboardInsightsRouteImport } from './routes/_auth/_dashboard/insights'
import { Route as AuthDashboardMealsRouteImport } from './routes/_auth/_dashboard/meals'
import { Route as AuthDashboardMetricsRouteImport } from './routes/_auth/_dashboard/metrics'
import { Route as AuthDashboardPackagesRouteImport } from './routes/_auth/_dashboard/packages'
import { Route as AuthDashboardReferRouteImport } from './routes/_auth/_dashboard/refer'
import { Route as AuthDashboardSupplementsRouteImport } from './routes/_auth/_dashboard/supplements'
import { Route as AuthDashboardTeamRouteImport } from './routes/_auth/_dashboard/team'
import { Route as AuthDashboardUpgradeRouteImport } from './routes/_auth/_dashboard/upgrade'
import { Route as AuthDashboardVaultRouteImport } from './routes/_auth/_dashboard/vault'
import { Route as OauthMcpConsentRouteImport } from './routes/oauth/mcp/consent'
import { Route as AuthDashboardClientsIndexRouteImport } from './routes/_auth/_dashboard/clients/index'
import { Route as AuthDashboardFormsIndexRouteImport } from './routes/_auth/_dashboard/forms/index'
import { Route as AuthDashboardFormsFormIdRouteImport } from './routes/_auth/_dashboard/forms/$formId'
import { Route as AuthDashboardLeadsIndexRouteImport } from './routes/_auth/_dashboard/leads/index'
import { Route as AuthDashboardLeadsLeadIdRouteImport } from './routes/_auth/_dashboard/leads/$leadId'
import { Route as AuthDashboardNutritionIndexRouteImport } from './routes/_auth/_dashboard/nutrition/index'
import { Route as AuthDashboardNutritionTemplateIdRouteImport } from './routes/_auth/_dashboard/nutrition/$templateId'
import { Route as AuthDashboardSettingsLayoutRouteImport } from './routes/_auth/_dashboard/settings/_layout'
import { Route as AuthDashboardTrainingIndexRouteImport } from './routes/_auth/_dashboard/training/index'
import { Route as AuthDashboardTrainingTemplateIdRouteImport } from './routes/_auth/_dashboard/training/$templateId'
import { Route as AuthDashboardWorkoutsIndexRouteImport } from './routes/_auth/_dashboard/workouts/index'
import { Route as AuthDashboardWorkoutsWorkoutIdRouteImport } from './routes/_auth/_dashboard/workouts/$workoutId'
import { Route as AuthDashboardClientsClientIdLayoutRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout'
import { Route as AuthDashboardSettingsLayoutIndexRouteImport } from './routes/_auth/_dashboard/settings/_layout/index'
import { Route as AuthDashboardSettingsLayoutConnectedAppsRouteImport } from './routes/_auth/_dashboard/settings/_layout/connected-apps'
import { Route as AuthDashboardSettingsLayoutOrganisationRouteImport } from './routes/_auth/_dashboard/settings/_layout/organisation'
import { Route as AuthDashboardSettingsLayoutSecurityRouteImport } from './routes/_auth/_dashboard/settings/_layout/security'
import { Route as AuthDashboardSettingsLayoutSubscriptionRouteImport } from './routes/_auth/_dashboard/settings/_layout/subscription'
import { Route as AuthDashboardClientsClientIdLayoutIndexRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/index'
import { Route as AuthDashboardClientsClientIdLayoutActivityRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/activity'
import { Route as AuthDashboardClientsClientIdLayoutGalleryRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/gallery'
import { Route as AuthDashboardClientsClientIdLayoutHabitsRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/habits'
import { Route as AuthDashboardClientsClientIdLayoutMetricsRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/metrics'
import { Route as AuthDashboardClientsClientIdLayoutNutritionRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/nutrition'
import { Route as AuthDashboardClientsClientIdLayoutRoadmapRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/roadmap'
import { Route as AuthDashboardClientsClientIdLayoutSettingsRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/settings'
import { Route as AuthDashboardClientsClientIdLayoutTrainingRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/training'
import { Route as AuthDashboardClientsClientIdLayoutVaultRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/vault'
import { Route as AuthDashboardClientsClientIdLayoutCheckinIndexRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/checkin/index'
import { Route as AuthDashboardClientsClientIdLayoutCheckinCompareRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/checkin/compare'
import { Route as AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRouteImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId.$responseId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const setupSetupRoute = setupSetupRouteImport.update({
  id: '/(setup)/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthForgotRoute = unauthForgotRouteImport.update({
  id: '/(unauth)/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthLoginRoute = unauthLoginRouteImport.update({
  id: '/(unauth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthRegisterRoute = unauthRegisterRouteImport.update({
  id: '/(unauth)/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkoutSessionRoute = AuthWorkoutSessionRouteImport.update({
  id: '/workout-session',
  path: '/workout-session',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardBrandingRoute = AuthDashboardBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardChatRoute = AuthDashboardChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardCheckinsRoute = AuthDashboardCheckinsRouteImport.update({
  id: '/checkins',
  path: '/checkins',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardDashboardRoute = AuthDashboardDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardExercisesRoute = AuthDashboardExercisesRouteImport.update({
  id: '/exercises',
  path: '/exercises',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardFoodsRoute = AuthDashboardFoodsRouteImport.update({
  id: '/foods',
  path: '/foods',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardGettingStartedRoute =
  AuthDashboardGettingStartedRouteImport.update({
    id: '/getting-started',
    path: '/getting-started',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardHabitsRoute = AuthDashboardHabitsRouteImport.update({
  id: '/habits',
  path: '/habits',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardInsightsRoute = AuthDashboardInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardMealsRoute = AuthDashboardMealsRouteImport.update({
  id: '/meals',
  path: '/meals',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardMetricsRoute = AuthDashboardMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardPackagesRoute = AuthDashboardPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardReferRoute = AuthDashboardReferRouteImport.update({
  id: '/refer',
  path: '/refer',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardSupplementsRoute =
  AuthDashboardSupplementsRouteImport.update({
    id: '/supplements',
    path: '/supplements',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardTeamRoute = AuthDashboardTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardUpgradeRoute = AuthDashboardUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardVaultRoute = AuthDashboardVaultRouteImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const OauthMcpConsentRoute = OauthMcpConsentRouteImport.update({
  id: '/oauth/mcp/consent',
  path: '/oauth/mcp/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDashboardClientsIndexRoute =
  AuthDashboardClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardFormsIndexRoute = AuthDashboardFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardFormsFormIdRoute =
  AuthDashboardFormsFormIdRouteImport.update({
    id: '/forms/$formId',
    path: '/forms/$formId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardLeadsIndexRoute = AuthDashboardLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthDashboardRoute,
} as any)
const AuthDashboardLeadsLeadIdRoute =
  AuthDashboardLeadsLeadIdRouteImport.update({
    id: '/leads/$leadId',
    path: '/leads/$leadId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardNutritionIndexRoute =
  AuthDashboardNutritionIndexRouteImport.update({
    id: '/nutrition/',
    path: '/nutrition/',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardNutritionTemplateIdRoute =
  AuthDashboardNutritionTemplateIdRouteImport.update({
    id: '/nutrition/$templateId',
    path: '/nutrition/$templateId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardSettingsLayoutRoute =
  AuthDashboardSettingsLayoutRouteImport.update({
    id: '/settings/_layout',
    path: '/settings',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardTrainingIndexRoute =
  AuthDashboardTrainingIndexRouteImport.update({
    id: '/training/',
    path: '/training/',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardTrainingTemplateIdRoute =
  AuthDashboardTrainingTemplateIdRouteImport.update({
    id: '/training/$templateId',
    path: '/training/$templateId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardWorkoutsIndexRoute =
  AuthDashboardWorkoutsIndexRouteImport.update({
    id: '/workouts/',
    path: '/workouts/',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardWorkoutsWorkoutIdRoute =
  AuthDashboardWorkoutsWorkoutIdRouteImport.update({
    id: '/workouts/$workoutId',
    path: '/workouts/$workoutId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutRoute =
  AuthDashboardClientsClientIdLayoutRouteImport.update({
    id: '/clients/$clientId/_layout',
    path: '/clients/$clientId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)
const AuthDashboardSettingsLayoutIndexRoute =
  AuthDashboardSettingsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)
const AuthDashboardSettingsLayoutConnectedAppsRoute =
  AuthDashboardSettingsLayoutConnectedAppsRouteImport.update({
    id: '/connected-apps',
    path: '/connected-apps',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)
const AuthDashboardSettingsLayoutOrganisationRoute =
  AuthDashboardSettingsLayoutOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)
const AuthDashboardSettingsLayoutSecurityRoute =
  AuthDashboardSettingsLayoutSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)
const AuthDashboardSettingsLayoutSubscriptionRoute =
  AuthDashboardSettingsLayoutSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutIndexRoute =
  AuthDashboardClientsClientIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutActivityRoute =
  AuthDashboardClientsClientIdLayoutActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutGalleryRoute =
  AuthDashboardClientsClientIdLayoutGalleryRouteImport.update({
    id: '/gallery',
    path: '/gallery',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutHabitsRoute =
  AuthDashboardClientsClientIdLayoutHabitsRouteImport.update({
    id: '/habits',
    path: '/habits',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutMetricsRoute =
  AuthDashboardClientsClientIdLayoutMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutNutritionRoute =
  AuthDashboardClientsClientIdLayoutNutritionRouteImport.update({
    id: '/nutrition',
    path: '/nutrition',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutRoadmapRoute =
  AuthDashboardClientsClientIdLayoutRoadmapRouteImport.update({
    id: '/roadmap',
    path: '/roadmap',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutSettingsRoute =
  AuthDashboardClientsClientIdLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutTrainingRoute =
  AuthDashboardClientsClientIdLayoutTrainingRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutVaultRoute =
  AuthDashboardClientsClientIdLayoutVaultRouteImport.update({
    id: '/vault',
    path: '/vault',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutCheckinIndexRoute =
  AuthDashboardClientsClientIdLayoutCheckinIndexRouteImport.update({
    id: '/checkin/',
    path: '/checkin/',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutCheckinCompareRoute =
  AuthDashboardClientsClientIdLayoutCheckinCompareRouteImport.update({
    id: '/checkin/compare',
    path: '/checkin/compare',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)
const AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute =
  AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRouteImport.update({
    id: '/checkin/$formId/$responseId',
    path: '/checkin/$formId/$responseId',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof setupSetupRoute
  '/forgot': typeof unauthForgotRoute
  '/login': typeof unauthLoginRoute
  '/register': typeof unauthRegisterRoute
  '/workout-session': typeof AuthWorkoutSessionRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/branding': typeof AuthDashboardBrandingRoute
  '/chat': typeof AuthDashboardChatRoute
  '/checkins': typeof AuthDashboardCheckinsRoute
  '/dashboard': typeof AuthDashboardDashboardRoute
  '/exercises': typeof AuthDashboardExercisesRoute
  '/foods': typeof AuthDashboardFoodsRoute
  '/getting-started': typeof AuthDashboardGettingStartedRoute
  '/habits': typeof AuthDashboardHabitsRoute
  '/insights': typeof AuthDashboardInsightsRoute
  '/meals': typeof AuthDashboardMealsRoute
  '/metrics': typeof AuthDashboardMetricsRoute
  '/packages': typeof AuthDashboardPackagesRoute
  '/refer': typeof AuthDashboardReferRoute
  '/supplements': typeof AuthDashboardSupplementsRoute
  '/team': typeof AuthDashboardTeamRoute
  '/upgrade': typeof AuthDashboardUpgradeRoute
  '/vault': typeof AuthDashboardVaultRoute
  '/oauth/mcp/consent': typeof OauthMcpConsentRoute
  '/forms/$formId': typeof AuthDashboardFormsFormIdRoute
  '/leads/$leadId': typeof AuthDashboardLeadsLeadIdRoute
  '/nutrition/$templateId': typeof AuthDashboardNutritionTemplateIdRoute
  '/settings': typeof AuthDashboardSettingsLayoutRouteWithChildren
  '/training/$templateId': typeof AuthDashboardTrainingTemplateIdRoute
  '/workouts/$workoutId': typeof AuthDashboardWorkoutsWorkoutIdRoute
  '/clients/': typeof AuthDashboardClientsIndexRoute
  '/forms/': typeof AuthDashboardFormsIndexRoute
  '/leads/': typeof AuthDashboardLeadsIndexRoute
  '/nutrition/': typeof AuthDashboardNutritionIndexRoute
  '/training/': typeof AuthDashboardTrainingIndexRoute
  '/workouts/': typeof AuthDashboardWorkoutsIndexRoute
  '/clients/$clientId': typeof AuthDashboardClientsClientIdLayoutRouteWithChildren
  '/settings/connected-apps': typeof AuthDashboardSettingsLayoutConnectedAppsRoute
  '/settings/organisation': typeof AuthDashboardSettingsLayoutOrganisationRoute
  '/settings/security': typeof AuthDashboardSettingsLayoutSecurityRoute
  '/settings/subscription': typeof AuthDashboardSettingsLayoutSubscriptionRoute
  '/settings/': typeof AuthDashboardSettingsLayoutIndexRoute
  '/clients/$clientId/activity': typeof AuthDashboardClientsClientIdLayoutActivityRoute
  '/clients/$clientId/gallery': typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  '/clients/$clientId/habits': typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  '/clients/$clientId/metrics': typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  '/clients/$clientId/nutrition': typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  '/clients/$clientId/roadmap': typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  '/clients/$clientId/settings': typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  '/clients/$clientId/training': typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  '/clients/$clientId/vault': typeof AuthDashboardClientsClientIdLayoutVaultRoute
  '/clients/$clientId/': typeof AuthDashboardClientsClientIdLayoutIndexRoute
  '/clients/$clientId/checkin/compare': typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  '/clients/$clientId/checkin/': typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  '/clients/$clientId/checkin/$formId/$responseId': typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof setupSetupRoute
  '/forgot': typeof unauthForgotRoute
  '/login': typeof unauthLoginRoute
  '/register': typeof unauthRegisterRoute
  '/workout-session': typeof AuthWorkoutSessionRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/branding': typeof AuthDashboardBrandingRoute
  '/chat': typeof AuthDashboardChatRoute
  '/checkins': typeof AuthDashboardCheckinsRoute
  '/dashboard': typeof AuthDashboardDashboardRoute
  '/exercises': typeof AuthDashboardExercisesRoute
  '/foods': typeof AuthDashboardFoodsRoute
  '/getting-started': typeof AuthDashboardGettingStartedRoute
  '/habits': typeof AuthDashboardHabitsRoute
  '/insights': typeof AuthDashboardInsightsRoute
  '/meals': typeof AuthDashboardMealsRoute
  '/metrics': typeof AuthDashboardMetricsRoute
  '/packages': typeof AuthDashboardPackagesRoute
  '/refer': typeof AuthDashboardReferRoute
  '/supplements': typeof AuthDashboardSupplementsRoute
  '/team': typeof AuthDashboardTeamRoute
  '/upgrade': typeof AuthDashboardUpgradeRoute
  '/vault': typeof AuthDashboardVaultRoute
  '/oauth/mcp/consent': typeof OauthMcpConsentRoute
  '/forms/$formId': typeof AuthDashboardFormsFormIdRoute
  '/leads/$leadId': typeof AuthDashboardLeadsLeadIdRoute
  '/nutrition/$templateId': typeof AuthDashboardNutritionTemplateIdRoute
  '/training/$templateId': typeof AuthDashboardTrainingTemplateIdRoute
  '/workouts/$workoutId': typeof AuthDashboardWorkoutsWorkoutIdRoute
  '/clients': typeof AuthDashboardClientsIndexRoute
  '/forms': typeof AuthDashboardFormsIndexRoute
  '/leads': typeof AuthDashboardLeadsIndexRoute
  '/nutrition': typeof AuthDashboardNutritionIndexRoute
  '/training': typeof AuthDashboardTrainingIndexRoute
  '/workouts': typeof AuthDashboardWorkoutsIndexRoute
  '/settings/connected-apps': typeof AuthDashboardSettingsLayoutConnectedAppsRoute
  '/settings/organisation': typeof AuthDashboardSettingsLayoutOrganisationRoute
  '/settings/security': typeof AuthDashboardSettingsLayoutSecurityRoute
  '/settings/subscription': typeof AuthDashboardSettingsLayoutSubscriptionRoute
  '/settings': typeof AuthDashboardSettingsLayoutIndexRoute
  '/clients/$clientId/activity': typeof AuthDashboardClientsClientIdLayoutActivityRoute
  '/clients/$clientId/gallery': typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  '/clients/$clientId/habits': typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  '/clients/$clientId/metrics': typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  '/clients/$clientId/nutrition': typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  '/clients/$clientId/roadmap': typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  '/clients/$clientId/settings': typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  '/clients/$clientId/training': typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  '/clients/$clientId/vault': typeof AuthDashboardClientsClientIdLayoutVaultRoute
  '/clients/$clientId': typeof AuthDashboardClientsClientIdLayoutIndexRoute
  '/clients/$clientId/checkin/compare': typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  '/clients/$clientId/checkin': typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  '/clients/$clientId/checkin/$formId/$responseId': typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/(setup)/setup': typeof setupSetupRoute
  '/(unauth)/forgot': typeof unauthForgotRoute
  '/(unauth)/login': typeof unauthLoginRoute
  '/(unauth)/register': typeof unauthRegisterRoute
  '/_auth/_dashboard': typeof AuthDashboardRouteWithChildren
  '/_auth/workout-session': typeof AuthWorkoutSessionRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/_auth/_dashboard/branding': typeof AuthDashboardBrandingRoute
  '/_auth/_dashboard/chat': typeof AuthDashboardChatRoute
  '/_auth/_dashboard/checkins': typeof AuthDashboardCheckinsRoute
  '/_auth/_dashboard/dashboard': typeof AuthDashboardDashboardRoute
  '/_auth/_dashboard/exercises': typeof AuthDashboardExercisesRoute
  '/_auth/_dashboard/foods': typeof AuthDashboardFoodsRoute
  '/_auth/_dashboard/getting-started': typeof AuthDashboardGettingStartedRoute
  '/_auth/_dashboard/habits': typeof AuthDashboardHabitsRoute
  '/_auth/_dashboard/insights': typeof AuthDashboardInsightsRoute
  '/_auth/_dashboard/meals': typeof AuthDashboardMealsRoute
  '/_auth/_dashboard/metrics': typeof AuthDashboardMetricsRoute
  '/_auth/_dashboard/packages': typeof AuthDashboardPackagesRoute
  '/_auth/_dashboard/refer': typeof AuthDashboardReferRoute
  '/_auth/_dashboard/supplements': typeof AuthDashboardSupplementsRoute
  '/_auth/_dashboard/team': typeof AuthDashboardTeamRoute
  '/_auth/_dashboard/upgrade': typeof AuthDashboardUpgradeRoute
  '/_auth/_dashboard/vault': typeof AuthDashboardVaultRoute
  '/oauth/mcp/consent': typeof OauthMcpConsentRoute
  '/_auth/_dashboard/forms/$formId': typeof AuthDashboardFormsFormIdRoute
  '/_auth/_dashboard/leads/$leadId': typeof AuthDashboardLeadsLeadIdRoute
  '/_auth/_dashboard/nutrition/$templateId': typeof AuthDashboardNutritionTemplateIdRoute
  '/_auth/_dashboard/settings/_layout': typeof AuthDashboardSettingsLayoutRouteWithChildren
  '/_auth/_dashboard/training/$templateId': typeof AuthDashboardTrainingTemplateIdRoute
  '/_auth/_dashboard/workouts/$workoutId': typeof AuthDashboardWorkoutsWorkoutIdRoute
  '/_auth/_dashboard/clients/': typeof AuthDashboardClientsIndexRoute
  '/_auth/_dashboard/forms/': typeof AuthDashboardFormsIndexRoute
  '/_auth/_dashboard/leads/': typeof AuthDashboardLeadsIndexRoute
  '/_auth/_dashboard/nutrition/': typeof AuthDashboardNutritionIndexRoute
  '/_auth/_dashboard/training/': typeof AuthDashboardTrainingIndexRoute
  '/_auth/_dashboard/workouts/': typeof AuthDashboardWorkoutsIndexRoute
  '/_auth/_dashboard/clients/$clientId/_layout': typeof AuthDashboardClientsClientIdLayoutRouteWithChildren
  '/_auth/_dashboard/settings/_layout/connected-apps': typeof AuthDashboardSettingsLayoutConnectedAppsRoute
  '/_auth/_dashboard/settings/_layout/organisation': typeof AuthDashboardSettingsLayoutOrganisationRoute
  '/_auth/_dashboard/settings/_layout/security': typeof AuthDashboardSettingsLayoutSecurityRoute
  '/_auth/_dashboard/settings/_layout/subscription': typeof AuthDashboardSettingsLayoutSubscriptionRoute
  '/_auth/_dashboard/settings/_layout/': typeof AuthDashboardSettingsLayoutIndexRoute
  '/_auth/_dashboard/clients/$clientId/_layout/activity': typeof AuthDashboardClientsClientIdLayoutActivityRoute
  '/_auth/_dashboard/clients/$clientId/_layout/gallery': typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  '/_auth/_dashboard/clients/$clientId/_layout/habits': typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  '/_auth/_dashboard/clients/$clientId/_layout/metrics': typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  '/_auth/_dashboard/clients/$clientId/_layout/nutrition': typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  '/_auth/_dashboard/clients/$clientId/_layout/roadmap': typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  '/_auth/_dashboard/clients/$clientId/_layout/settings': typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  '/_auth/_dashboard/clients/$clientId/_layout/training': typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  '/_auth/_dashboard/clients/$clientId/_layout/vault': typeof AuthDashboardClientsClientIdLayoutVaultRoute
  '/_auth/_dashboard/clients/$clientId/_layout/': typeof AuthDashboardClientsClientIdLayoutIndexRoute
  '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare': typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  '/_auth/_dashboard/clients/$clientId/_layout/checkin/': typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId': typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/join'
    | '/reset-password'
    | '/setup'
    | '/forgot'
    | '/login'
    | '/register'
    | '/workout-session'
    | '/auth/callback'
    | '/oauth/consent'
    | '/branding'
    | '/chat'
    | '/checkins'
    | '/dashboard'
    | '/exercises'
    | '/foods'
    | '/getting-started'
    | '/habits'
    | '/insights'
    | '/meals'
    | '/metrics'
    | '/packages'
    | '/refer'
    | '/supplements'
    | '/team'
    | '/upgrade'
    | '/vault'
    | '/oauth/mcp/consent'
    | '/forms/$formId'
    | '/leads/$leadId'
    | '/nutrition/$templateId'
    | '/settings'
    | '/training/$templateId'
    | '/workouts/$workoutId'
    | '/clients/'
    | '/forms/'
    | '/leads/'
    | '/nutrition/'
    | '/training/'
    | '/workouts/'
    | '/clients/$clientId'
    | '/settings/connected-apps'
    | '/settings/organisation'
    | '/settings/security'
    | '/settings/subscription'
    | '/settings/'
    | '/clients/$clientId/activity'
    | '/clients/$clientId/gallery'
    | '/clients/$clientId/habits'
    | '/clients/$clientId/metrics'
    | '/clients/$clientId/nutrition'
    | '/clients/$clientId/roadmap'
    | '/clients/$clientId/settings'
    | '/clients/$clientId/training'
    | '/clients/$clientId/vault'
    | '/clients/$clientId/'
    | '/clients/$clientId/checkin/compare'
    | '/clients/$clientId/checkin/'
    | '/clients/$clientId/checkin/$formId/$responseId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/join'
    | '/reset-password'
    | '/setup'
    | '/forgot'
    | '/login'
    | '/register'
    | '/workout-session'
    | '/auth/callback'
    | '/oauth/consent'
    | '/branding'
    | '/chat'
    | '/checkins'
    | '/dashboard'
    | '/exercises'
    | '/foods'
    | '/getting-started'
    | '/habits'
    | '/insights'
    | '/meals'
    | '/metrics'
    | '/packages'
    | '/refer'
    | '/supplements'
    | '/team'
    | '/upgrade'
    | '/vault'
    | '/oauth/mcp/consent'
    | '/forms/$formId'
    | '/leads/$leadId'
    | '/nutrition/$templateId'
    | '/training/$templateId'
    | '/workouts/$workoutId'
    | '/clients'
    | '/forms'
    | '/leads'
    | '/nutrition'
    | '/training'
    | '/workouts'
    | '/settings/connected-apps'
    | '/settings/organisation'
    | '/settings/security'
    | '/settings/subscription'
    | '/settings'
    | '/clients/$clientId/activity'
    | '/clients/$clientId/gallery'
    | '/clients/$clientId/habits'
    | '/clients/$clientId/metrics'
    | '/clients/$clientId/nutrition'
    | '/clients/$clientId/roadmap'
    | '/clients/$clientId/settings'
    | '/clients/$clientId/training'
    | '/clients/$clientId/vault'
    | '/clients/$clientId'
    | '/clients/$clientId/checkin/compare'
    | '/clients/$clientId/checkin'
    | '/clients/$clientId/checkin/$formId/$responseId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/join'
    | '/reset-password'
    | '/(setup)/setup'
    | '/(unauth)/forgot'
    | '/(unauth)/login'
    | '/(unauth)/register'
    | '/_auth/_dashboard'
    | '/_auth/workout-session'
    | '/auth/callback'
    | '/oauth/consent'
    | '/_auth/_dashboard/branding'
    | '/_auth/_dashboard/chat'
    | '/_auth/_dashboard/checkins'
    | '/_auth/_dashboard/dashboard'
    | '/_auth/_dashboard/exercises'
    | '/_auth/_dashboard/foods'
    | '/_auth/_dashboard/getting-started'
    | '/_auth/_dashboard/habits'
    | '/_auth/_dashboard/insights'
    | '/_auth/_dashboard/meals'
    | '/_auth/_dashboard/metrics'
    | '/_auth/_dashboard/packages'
    | '/_auth/_dashboard/refer'
    | '/_auth/_dashboard/supplements'
    | '/_auth/_dashboard/team'
    | '/_auth/_dashboard/upgrade'
    | '/_auth/_dashboard/vault'
    | '/oauth/mcp/consent'
    | '/_auth/_dashboard/forms/$formId'
    | '/_auth/_dashboard/leads/$leadId'
    | '/_auth/_dashboard/nutrition/$templateId'
    | '/_auth/_dashboard/settings/_layout'
    | '/_auth/_dashboard/training/$templateId'
    | '/_auth/_dashboard/workouts/$workoutId'
    | '/_auth/_dashboard/clients/'
    | '/_auth/_dashboard/forms/'
    | '/_auth/_dashboard/leads/'
    | '/_auth/_dashboard/nutrition/'
    | '/_auth/_dashboard/training/'
    | '/_auth/_dashboard/workouts/'
    | '/_auth/_dashboard/clients/$clientId/_layout'
    | '/_auth/_dashboard/settings/_layout/connected-apps'
    | '/_auth/_dashboard/settings/_layout/organisation'
    | '/_auth/_dashboard/settings/_layout/security'
    | '/_auth/_dashboard/settings/_layout/subscription'
    | '/_auth/_dashboard/settings/_layout/'
    | '/_auth/_dashboard/clients/$clientId/_layout/activity'
    | '/_auth/_dashboard/clients/$clientId/_layout/gallery'
    | '/_auth/_dashboard/clients/$clientId/_layout/habits'
    | '/_auth/_dashboard/clients/$clientId/_layout/metrics'
    | '/_auth/_dashboard/clients/$clientId/_layout/nutrition'
    | '/_auth/_dashboard/clients/$clientId/_layout/roadmap'
    | '/_auth/_dashboard/clients/$clientId/_layout/settings'
    | '/_auth/_dashboard/clients/$clientId/_layout/training'
    | '/_auth/_dashboard/clients/$clientId/_layout/vault'
    | '/_auth/_dashboard/clients/$clientId/_layout/'
    | '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare'
    | '/_auth/_dashboard/clients/$clientId/_layout/checkin/'
    | '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  JoinRoute: typeof JoinRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  setupSetupRoute: typeof setupSetupRoute
  unauthForgotRoute: typeof unauthForgotRoute
  unauthLoginRoute: typeof unauthLoginRoute
  unauthRegisterRoute: typeof unauthRegisterRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OauthMcpConsentRoute: typeof OauthMcpConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(setup)/setup': {
      id: '/(setup)/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof setupSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauth)/forgot': {
      id: '/(unauth)/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof unauthForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauth)/login': {
      id: '/(unauth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof unauthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauth)/register': {
      id: '/(unauth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof unauthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_dashboard': {
      id: '/_auth/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workout-session': {
      id: '/_auth/workout-session'
      path: '/workout-session'
      fullPath: '/workout-session'
      preLoaderRoute: typeof AuthWorkoutSessionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_dashboard/branding': {
      id: '/_auth/_dashboard/branding'
      path: '/branding'
      fullPath: '/branding'
      preLoaderRoute: typeof AuthDashboardBrandingRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/chat': {
      id: '/_auth/_dashboard/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthDashboardChatRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/checkins': {
      id: '/_auth/_dashboard/checkins'
      path: '/checkins'
      fullPath: '/checkins'
      preLoaderRoute: typeof AuthDashboardCheckinsRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/dashboard': {
      id: '/_auth/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardDashboardRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/exercises': {
      id: '/_auth/_dashboard/exercises'
      path: '/exercises'
      fullPath: '/exercises'
      preLoaderRoute: typeof AuthDashboardExercisesRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/foods': {
      id: '/_auth/_dashboard/foods'
      path: '/foods'
      fullPath: '/foods'
      preLoaderRoute: typeof AuthDashboardFoodsRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/getting-started': {
      id: '/_auth/_dashboard/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof AuthDashboardGettingStartedRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/habits': {
      id: '/_auth/_dashboard/habits'
      path: '/habits'
      fullPath: '/habits'
      preLoaderRoute: typeof AuthDashboardHabitsRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/insights': {
      id: '/_auth/_dashboard/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AuthDashboardInsightsRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/meals': {
      id: '/_auth/_dashboard/meals'
      path: '/meals'
      fullPath: '/meals'
      preLoaderRoute: typeof AuthDashboardMealsRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/metrics': {
      id: '/_auth/_dashboard/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof AuthDashboardMetricsRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/packages': {
      id: '/_auth/_dashboard/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof AuthDashboardPackagesRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/refer': {
      id: '/_auth/_dashboard/refer'
      path: '/refer'
      fullPath: '/refer'
      preLoaderRoute: typeof AuthDashboardReferRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/supplements': {
      id: '/_auth/_dashboard/supplements'
      path: '/supplements'
      fullPath: '/supplements'
      preLoaderRoute: typeof AuthDashboardSupplementsRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/team': {
      id: '/_auth/_dashboard/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthDashboardTeamRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/upgrade': {
      id: '/_auth/_dashboard/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AuthDashboardUpgradeRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/vault': {
      id: '/_auth/_dashboard/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof AuthDashboardVaultRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/oauth/mcp/consent': {
      id: '/oauth/mcp/consent'
      path: '/oauth/mcp/consent'
      fullPath: '/oauth/mcp/consent'
      preLoaderRoute: typeof OauthMcpConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_dashboard/clients/': {
      id: '/_auth/_dashboard/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthDashboardClientsIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/forms/': {
      id: '/_auth/_dashboard/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof AuthDashboardFormsIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/forms/$formId': {
      id: '/_auth/_dashboard/forms/$formId'
      path: '/forms/$formId'
      fullPath: '/forms/$formId'
      preLoaderRoute: typeof AuthDashboardFormsFormIdRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/leads/': {
      id: '/_auth/_dashboard/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AuthDashboardLeadsIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/leads/$leadId': {
      id: '/_auth/_dashboard/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AuthDashboardLeadsLeadIdRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/nutrition/': {
      id: '/_auth/_dashboard/nutrition/'
      path: '/nutrition'
      fullPath: '/nutrition/'
      preLoaderRoute: typeof AuthDashboardNutritionIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/nutrition/$templateId': {
      id: '/_auth/_dashboard/nutrition/$templateId'
      path: '/nutrition/$templateId'
      fullPath: '/nutrition/$templateId'
      preLoaderRoute: typeof AuthDashboardNutritionTemplateIdRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/settings/_layout': {
      id: '/_auth/_dashboard/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/training/': {
      id: '/_auth/_dashboard/training/'
      path: '/training'
      fullPath: '/training/'
      preLoaderRoute: typeof AuthDashboardTrainingIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/training/$templateId': {
      id: '/_auth/_dashboard/training/$templateId'
      path: '/training/$templateId'
      fullPath: '/training/$templateId'
      preLoaderRoute: typeof AuthDashboardTrainingTemplateIdRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/workouts/': {
      id: '/_auth/_dashboard/workouts/'
      path: '/workouts'
      fullPath: '/workouts/'
      preLoaderRoute: typeof AuthDashboardWorkoutsIndexRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/workouts/$workoutId': {
      id: '/_auth/_dashboard/workouts/$workoutId'
      path: '/workouts/$workoutId'
      fullPath: '/workouts/$workoutId'
      preLoaderRoute: typeof AuthDashboardWorkoutsWorkoutIdRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout': {
      id: '/_auth/_dashboard/clients/$clientId/_layout'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutRouteImport
      parentRoute: typeof AuthDashboardRoute
    }
    '/_auth/_dashboard/settings/_layout/': {
      id: '/_auth/_dashboard/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutIndexRouteImport
      parentRoute: typeof AuthDashboardSettingsLayoutRoute
    }
    '/_auth/_dashboard/settings/_layout/connected-apps': {
      id: '/_auth/_dashboard/settings/_layout/connected-apps'
      path: '/connected-apps'
      fullPath: '/settings/connected-apps'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutConnectedAppsRouteImport
      parentRoute: typeof AuthDashboardSettingsLayoutRoute
    }
    '/_auth/_dashboard/settings/_layout/organisation': {
      id: '/_auth/_dashboard/settings/_layout/organisation'
      path: '/organisation'
      fullPath: '/settings/organisation'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutOrganisationRouteImport
      parentRoute: typeof AuthDashboardSettingsLayoutRoute
    }
    '/_auth/_dashboard/settings/_layout/security': {
      id: '/_auth/_dashboard/settings/_layout/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutSecurityRouteImport
      parentRoute: typeof AuthDashboardSettingsLayoutRoute
    }
    '/_auth/_dashboard/settings/_layout/subscription': {
      id: '/_auth/_dashboard/settings/_layout/subscription'
      path: '/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutSubscriptionRouteImport
      parentRoute: typeof AuthDashboardSettingsLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/'
      path: '/'
      fullPath: '/clients/$clientId/'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutIndexRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/activity': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/activity'
      path: '/activity'
      fullPath: '/clients/$clientId/activity'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutActivityRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/gallery': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/gallery'
      path: '/gallery'
      fullPath: '/clients/$clientId/gallery'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutGalleryRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/habits': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/habits'
      path: '/habits'
      fullPath: '/clients/$clientId/habits'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutHabitsRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/metrics': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/metrics'
      path: '/metrics'
      fullPath: '/clients/$clientId/metrics'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutMetricsRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/nutrition': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/nutrition'
      path: '/nutrition'
      fullPath: '/clients/$clientId/nutrition'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutNutritionRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/roadmap': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/roadmap'
      path: '/roadmap'
      fullPath: '/clients/$clientId/roadmap'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutRoadmapRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/settings': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/settings'
      path: '/settings'
      fullPath: '/clients/$clientId/settings'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutSettingsRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/training': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/training'
      path: '/training'
      fullPath: '/clients/$clientId/training'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutTrainingRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/vault': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/vault'
      path: '/vault'
      fullPath: '/clients/$clientId/vault'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutVaultRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/checkin/': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/checkin/'
      path: '/checkin'
      fullPath: '/clients/$clientId/checkin/'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutCheckinIndexRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare'
      path: '/checkin/compare'
      fullPath: '/clients/$clientId/checkin/compare'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutCheckinCompareRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
    '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId'
      path: '/checkin/$formId/$responseId'
      fullPath: '/clients/$clientId/checkin/$formId/$responseId'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRouteImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutRoute
    }
  }
}

interface AuthDashboardSettingsLayoutRouteChildren {
  AuthDashboardSettingsLayoutConnectedAppsRoute: typeof AuthDashboardSettingsLayoutConnectedAppsRoute
  AuthDashboardSettingsLayoutOrganisationRoute: typeof AuthDashboardSettingsLayoutOrganisationRoute
  AuthDashboardSettingsLayoutSecurityRoute: typeof AuthDashboardSettingsLayoutSecurityRoute
  AuthDashboardSettingsLayoutSubscriptionRoute: typeof AuthDashboardSettingsLayoutSubscriptionRoute
  AuthDashboardSettingsLayoutIndexRoute: typeof AuthDashboardSettingsLayoutIndexRoute
}

const AuthDashboardSettingsLayoutRouteChildren: AuthDashboardSettingsLayoutRouteChildren =
  {
    AuthDashboardSettingsLayoutConnectedAppsRoute:
      AuthDashboardSettingsLayoutConnectedAppsRoute,
    AuthDashboardSettingsLayoutOrganisationRoute:
      AuthDashboardSettingsLayoutOrganisationRoute,
    AuthDashboardSettingsLayoutSecurityRoute:
      AuthDashboardSettingsLayoutSecurityRoute,
    AuthDashboardSettingsLayoutSubscriptionRoute:
      AuthDashboardSettingsLayoutSubscriptionRoute,
    AuthDashboardSettingsLayoutIndexRoute:
      AuthDashboardSettingsLayoutIndexRoute,
  }

const AuthDashboardSettingsLayoutRouteWithChildren =
  AuthDashboardSettingsLayoutRoute._addFileChildren(
    AuthDashboardSettingsLayoutRouteChildren,
  )

interface AuthDashboardClientsClientIdLayoutRouteChildren {
  AuthDashboardClientsClientIdLayoutActivityRoute: typeof AuthDashboardClientsClientIdLayoutActivityRoute
  AuthDashboardClientsClientIdLayoutGalleryRoute: typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  AuthDashboardClientsClientIdLayoutHabitsRoute: typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  AuthDashboardClientsClientIdLayoutMetricsRoute: typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  AuthDashboardClientsClientIdLayoutNutritionRoute: typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  AuthDashboardClientsClientIdLayoutRoadmapRoute: typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  AuthDashboardClientsClientIdLayoutSettingsRoute: typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  AuthDashboardClientsClientIdLayoutTrainingRoute: typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  AuthDashboardClientsClientIdLayoutVaultRoute: typeof AuthDashboardClientsClientIdLayoutVaultRoute
  AuthDashboardClientsClientIdLayoutIndexRoute: typeof AuthDashboardClientsClientIdLayoutIndexRoute
  AuthDashboardClientsClientIdLayoutCheckinCompareRoute: typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  AuthDashboardClientsClientIdLayoutCheckinIndexRoute: typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute: typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}

const AuthDashboardClientsClientIdLayoutRouteChildren: AuthDashboardClientsClientIdLayoutRouteChildren =
  {
    AuthDashboardClientsClientIdLayoutActivityRoute:
      AuthDashboardClientsClientIdLayoutActivityRoute,
    AuthDashboardClientsClientIdLayoutGalleryRoute:
      AuthDashboardClientsClientIdLayoutGalleryRoute,
    AuthDashboardClientsClientIdLayoutHabitsRoute:
      AuthDashboardClientsClientIdLayoutHabitsRoute,
    AuthDashboardClientsClientIdLayoutMetricsRoute:
      AuthDashboardClientsClientIdLayoutMetricsRoute,
    AuthDashboardClientsClientIdLayoutNutritionRoute:
      AuthDashboardClientsClientIdLayoutNutritionRoute,
    AuthDashboardClientsClientIdLayoutRoadmapRoute:
      AuthDashboardClientsClientIdLayoutRoadmapRoute,
    AuthDashboardClientsClientIdLayoutSettingsRoute:
      AuthDashboardClientsClientIdLayoutSettingsRoute,
    AuthDashboardClientsClientIdLayoutTrainingRoute:
      AuthDashboardClientsClientIdLayoutTrainingRoute,
    AuthDashboardClientsClientIdLayoutVaultRoute:
      AuthDashboardClientsClientIdLayoutVaultRoute,
    AuthDashboardClientsClientIdLayoutIndexRoute:
      AuthDashboardClientsClientIdLayoutIndexRoute,
    AuthDashboardClientsClientIdLayoutCheckinCompareRoute:
      AuthDashboardClientsClientIdLayoutCheckinCompareRoute,
    AuthDashboardClientsClientIdLayoutCheckinIndexRoute:
      AuthDashboardClientsClientIdLayoutCheckinIndexRoute,
    AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute:
      AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute,
  }

const AuthDashboardClientsClientIdLayoutRouteWithChildren =
  AuthDashboardClientsClientIdLayoutRoute._addFileChildren(
    AuthDashboardClientsClientIdLayoutRouteChildren,
  )

interface AuthDashboardRouteChildren {
  AuthDashboardBrandingRoute: typeof AuthDashboardBrandingRoute
  AuthDashboardChatRoute: typeof AuthDashboardChatRoute
  AuthDashboardCheckinsRoute: typeof AuthDashboardCheckinsRoute
  AuthDashboardDashboardRoute: typeof AuthDashboardDashboardRoute
  AuthDashboardExercisesRoute: typeof AuthDashboardExercisesRoute
  AuthDashboardFoodsRoute: typeof AuthDashboardFoodsRoute
  AuthDashboardGettingStartedRoute: typeof AuthDashboardGettingStartedRoute
  AuthDashboardHabitsRoute: typeof AuthDashboardHabitsRoute
  AuthDashboardInsightsRoute: typeof AuthDashboardInsightsRoute
  AuthDashboardMealsRoute: typeof AuthDashboardMealsRoute
  AuthDashboardMetricsRoute: typeof AuthDashboardMetricsRoute
  AuthDashboardPackagesRoute: typeof AuthDashboardPackagesRoute
  AuthDashboardReferRoute: typeof AuthDashboardReferRoute
  AuthDashboardSupplementsRoute: typeof AuthDashboardSupplementsRoute
  AuthDashboardTeamRoute: typeof AuthDashboardTeamRoute
  AuthDashboardUpgradeRoute: typeof AuthDashboardUpgradeRoute
  AuthDashboardVaultRoute: typeof AuthDashboardVaultRoute
  AuthDashboardFormsFormIdRoute: typeof AuthDashboardFormsFormIdRoute
  AuthDashboardLeadsLeadIdRoute: typeof AuthDashboardLeadsLeadIdRoute
  AuthDashboardNutritionTemplateIdRoute: typeof AuthDashboardNutritionTemplateIdRoute
  AuthDashboardSettingsLayoutRoute: typeof AuthDashboardSettingsLayoutRouteWithChildren
  AuthDashboardTrainingTemplateIdRoute: typeof AuthDashboardTrainingTemplateIdRoute
  AuthDashboardWorkoutsWorkoutIdRoute: typeof AuthDashboardWorkoutsWorkoutIdRoute
  AuthDashboardClientsIndexRoute: typeof AuthDashboardClientsIndexRoute
  AuthDashboardFormsIndexRoute: typeof AuthDashboardFormsIndexRoute
  AuthDashboardLeadsIndexRoute: typeof AuthDashboardLeadsIndexRoute
  AuthDashboardNutritionIndexRoute: typeof AuthDashboardNutritionIndexRoute
  AuthDashboardTrainingIndexRoute: typeof AuthDashboardTrainingIndexRoute
  AuthDashboardWorkoutsIndexRoute: typeof AuthDashboardWorkoutsIndexRoute
  AuthDashboardClientsClientIdLayoutRoute: typeof AuthDashboardClientsClientIdLayoutRouteWithChildren
}

const AuthDashboardRouteChildren: AuthDashboardRouteChildren = {
  AuthDashboardBrandingRoute: AuthDashboardBrandingRoute,
  AuthDashboardChatRoute: AuthDashboardChatRoute,
  AuthDashboardCheckinsRoute: AuthDashboardCheckinsRoute,
  AuthDashboardDashboardRoute: AuthDashboardDashboardRoute,
  AuthDashboardExercisesRoute: AuthDashboardExercisesRoute,
  AuthDashboardFoodsRoute: AuthDashboardFoodsRoute,
  AuthDashboardGettingStartedRoute: AuthDashboardGettingStartedRoute,
  AuthDashboardHabitsRoute: AuthDashboardHabitsRoute,
  AuthDashboardInsightsRoute: AuthDashboardInsightsRoute,
  AuthDashboardMealsRoute: AuthDashboardMealsRoute,
  AuthDashboardMetricsRoute: AuthDashboardMetricsRoute,
  AuthDashboardPackagesRoute: AuthDashboardPackagesRoute,
  AuthDashboardReferRoute: AuthDashboardReferRoute,
  AuthDashboardSupplementsRoute: AuthDashboardSupplementsRoute,
  AuthDashboardTeamRoute: AuthDashboardTeamRoute,
  AuthDashboardUpgradeRoute: AuthDashboardUpgradeRoute,
  AuthDashboardVaultRoute: AuthDashboardVaultRoute,
  AuthDashboardFormsFormIdRoute: AuthDashboardFormsFormIdRoute,
  AuthDashboardLeadsLeadIdRoute: AuthDashboardLeadsLeadIdRoute,
  AuthDashboardNutritionTemplateIdRoute: AuthDashboardNutritionTemplateIdRoute,
  AuthDashboardSettingsLayoutRoute:
    AuthDashboardSettingsLayoutRouteWithChildren,
  AuthDashboardTrainingTemplateIdRoute: AuthDashboardTrainingTemplateIdRoute,
  AuthDashboardWorkoutsWorkoutIdRoute: AuthDashboardWorkoutsWorkoutIdRoute,
  AuthDashboardClientsIndexRoute: AuthDashboardClientsIndexRoute,
  AuthDashboardFormsIndexRoute: AuthDashboardFormsIndexRoute,
  AuthDashboardLeadsIndexRoute: AuthDashboardLeadsIndexRoute,
  AuthDashboardNutritionIndexRoute: AuthDashboardNutritionIndexRoute,
  AuthDashboardTrainingIndexRoute: AuthDashboardTrainingIndexRoute,
  AuthDashboardWorkoutsIndexRoute: AuthDashboardWorkoutsIndexRoute,
  AuthDashboardClientsClientIdLayoutRoute:
    AuthDashboardClientsClientIdLayoutRouteWithChildren,
}

const AuthDashboardRouteWithChildren = AuthDashboardRoute._addFileChildren(
  AuthDashboardRouteChildren,
)

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRouteWithChildren
  AuthWorkoutSessionRoute: typeof AuthWorkoutSessionRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRouteWithChildren,
  AuthWorkoutSessionRoute: AuthWorkoutSessionRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  JoinRoute: JoinRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  setupSetupRoute: setupSetupRoute,
  unauthForgotRoute: unauthForgotRoute,
  unauthLoginRoute: unauthLoginRoute,
  unauthRegisterRoute: unauthRegisterRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  OauthConsentRoute: OauthConsentRoute,
  OauthMcpConsentRoute: OauthMcpConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
